import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Routes } from "src/app/infrastructure/routes";
import { DocumentEmailReadGateway } from "../gateway/DocumentEmailReadGateway";
import { PageResult } from "src/app/domain/models/PageResult";
import { DocumentEmailReadReportParams, DocumentEmailReads, DocumentEmailReadsParams } from "src/app/domain/models/DocumentEmailRead";

@Injectable({providedIn: 'root'})
export class DocumentEmailReadService extends DocumentEmailReadGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  getDocumentEmailReads(request: DocumentEmailReadsParams): Observable<PageResult<DocumentEmailReads>> {
    return this._http.get<PageResult<DocumentEmailReads>>(Routes.documentEmailReadApi + '/GetDocumentEmailReads', { params: {...request}});
  }

  getDocumentToAssign(request: DocumentEmailReadsParams): Observable<PageResult<DocumentEmailReads>> {
    return this._http.get<PageResult<DocumentEmailReads>>(Routes.documentEmailReadApi + '/GetDocumentToAssign', { params: {...request}});
  }

  getEmailDocument(documentEmailReadId: string): Observable<any> {
      const headers = new HttpHeaders({
        'Content-Type':  'application/pdf'
      })
    return this._http.get<any>(Routes.documentEmailReadApi + '/GetEmailDocument',
      { params: {documentEmailReadId}, headers: headers, observe: 'response', responseType: 'blob' as 'json'});
  }

  deleteDocument(documentEmailReadId: string): Observable<any> {
    return this._http.delete<any>(Routes.documentEmailReadApi + '/DeleteDocument', {params: {documentEmailReadId}});
  }

  downloadReport(request: DocumentEmailReadReportParams): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type':  'application/octet-stream'
    })
    return this._http.get<any>(Routes.documentEmailReadApi + '/DownloadReport',
      { params: {...request}, headers: headers, observe: 'response', responseType: 'blob' as 'json'});
  }
}
